import { OrgAdminConstants } from '../../../_constants';

const initialState = { moveToDifferentTeamLoading: true, data: '', error: false };

export function moveToDifferentTeamReducer(state = initialState, action) {

    switch (action.type) {
        case OrgAdminConstants.REQUEST_MOVE_TO_DIFFERENT_TEAM:
            return {
                moveToDifferentTeamLoading: true,
                data: '',
                error: false
            };
        case OrgAdminConstants.RECEIVE_MOVE_TO_DIFFERENT_TEAM:
            return {
                moveToDifferentTeamLoading: false,
                data: action.moveToDifferentTeam,
                error: false
            };
        case OrgAdminConstants.MOVE_TO_DIFFERENT_TEAM_ERROR:
            return {
                moveToDifferentTeamLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/OrgAdmin/ManageTeam/moveToDifferentTeam.reducer.js